
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/patients/choose.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import { useTranslation } from 'react-i18next';
import SelectClinicianSlotAndConfirmBooking from 'vl-common/src/components/BookAppointment/SelectClinicianSlotAndConfirmBooking';
import useBookingFlowData from 'vl-common/src/hooks/useBookingFlowData';
import router from '@hooks/useRouter';
import { useQueryClient } from '@tanstack/react-query';
import StartNextSurveyModal from '@components/Modal/StartNextSurveyModal';
import { appointmentBookedQueriesToInvalidate } from 'vl-common/src/lib/bookingQueryKeys';
import SuccessBookingMessage from 'vl-common/src/components/BookAppointment/SuccessBookingMessage';
import Header from '@components/Layouts/Header/Header';
import PageHead from '@components/Layouts/PageHead/PageHead';

const PatientsChoose = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const { bookingData } = useBookingFlowData();
  const queryClient = useQueryClient();

  const onSuccessBooking = () => setConfirmModalVisible(true);

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  const redirect = async () => {
    await router.push(bookingData?.redirectRoute ?? '/patients');
    await Promise.all(
      appointmentBookedQueriesToInvalidate.map((queryKey) => queryClient.invalidateQueries({ queryKey }))
    );
  };

  if (!bookingData?.caseId) {
    return null;
  }

  return (
    <div className="page-container">
      <Header pageType="patients" pageTitle="Choose" />

      <section className="section-layout patient">
        <main className="container" id="page-content">
          <PageHead backUrl={bookingData?.redirectRoute ?? '/patients'} backArrow backText="Back" />

          <SelectClinicianSlotAndConfirmBooking onSuccessBooking={onSuccessBooking} />
          <StartNextSurveyModal
            showModal={confirmModalVisible}
            caseId={bookingData.caseId}
            setShowModal={setConfirmModalVisible}
            onCancelModal={redirect}
            continueDataTestid="continue-to-survey"
            title={t('All booked')}
            subtitle={
              <SuccessBookingMessage
                apptDate={bookingData?.apptDate}
                callType={bookingData?.callType}
                clinicianName={bookingData?.clinician?.name}
              />
            }
          />
        </main>
      </section>
    </div>
  );
};


export const Route = createFileRoute('/patients/choose')({ component: PatientsChoose });
